export default __webpack_public_path__ + "_/images/app/ios/ios-ru-1-84c86ea9bf4467fed3fd18bec1616f08e01e5dee6130e6c4a6bf01975b4ba142.png";